import { useState } from "react";
import { Menu } from "lucide-react";

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

// Menú lateral para móvil (teléfono). Reúne las acciones secundarias de la barra superior
// de Terminal/Valet. Cada opción muestra ícono + texto y es táctil (altura cómoda).
// Reutiliza los handlers existentes: no crea funciones nuevas ni cambia permisos.
const toneClasses = {
  default: "bg-white/5 border-white/15 text-white hover:bg-white/10",
  active: "bg-[#FFCC00]/15 border-[#FFCC00]/50 text-[#FFCC00] hover:bg-[#FFCC00]/25",
  warn: "bg-[#F59E0B]/15 border-[#F59E0B]/50 text-[#F59E0B] hover:bg-[#F59E0B]/25",
  danger: "bg-[#EF4444]/10 border-[#EF4444]/40 text-[#EF4444] hover:bg-[#EF4444]/20",
};

export default function OperativeMobileMenu({ items = [], testid = "mobile-menu" }) {
  const [open, setOpen] = useState(false);
  const visible = items.filter(Boolean);

  const handleClick = (fn) => {
    setOpen(false);
    // deja cerrar el panel antes de abrir un modal (evita conflicto de overlays)
    setTimeout(() => { try { fn?.(); } catch { /* noop */ } }, 60);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`${testid}-trigger`}
        aria-label="Abrir menú"
        className="md:hidden btn-hard h-11 w-11 shrink-0 bg-white/5 border border-white/20 text-white flex items-center justify-center hover:bg-white/10"
      >
        <Menu className="h-5 w-5" />
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" onInteractOutside={() => setOpen(false)} onPointerDownOutside={() => setOpen(false)} className="w-[84vw] max-w-xs bg-[#0A0A0A] border-l border-white/10 text-white p-0 flex flex-col" data-testid={`${testid}-panel`}>
          <SheetHeader className="px-5 py-4 border-b border-white/10 text-left">
            <SheetTitle className="font-display font-black uppercase tracking-wider text-white text-base">Menú</SheetTitle>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto p-3 space-y-2">
            {visible.map((it, i) => {
              const Icon = it.icon;
              return (
                <button
                  key={it.testid || i}
                  type="button"
                  onClick={() => handleClick(it.onClick)}
                  data-testid={it.testid}
                  className={`btn-hard w-full h-14 px-4 border flex items-center gap-3 font-bold uppercase tracking-wider text-sm ${toneClasses[it.tone || "default"]}`}
                >
                  {Icon ? <Icon className="h-5 w-5 shrink-0" /> : null}
                  <span className="truncate">{it.label}</span>
                </button>
              );
            })}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
